import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';
import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.posts.item');
import { OnInit } from '@angular/core';
import { Service } from 'src/libs/portal/season/service';

@Component({
 standalone: false,
 selector: 'wiz-page-posts-item',
template: templateSource || '',
    styles: [``],
})
export class PagePostsItemComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow("/access");
    }
}

export default PagePostsItemComponent;
